// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Xpr","option":"styles_option__1uWY7","selected":"styles_selected__RzVOE"};